import "./poster-builder.7ec0a949.js";
import "./poster-builder.b2a72de8.js";
import "./poster-builder.f3c75a3b.js";
import "./poster-builder.40ac639a.js";
import "./poster-builder.e6ead1b7.js";
import "./poster-builder.cc8ec761.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Import components
parcelRequire("1enj3");
parcelRequire("eBwC4");
parcelRequire("ekXg5");
parcelRequire("9hC2G");
parcelRequire("3skPo");
parcelRequire("fzSrD");
/*
 *  jQuery Dropdown Datepicker - v1.3.0
 *  A simple customizable jquery dropdown datepicker
 *
 *  Made by Md Shafkat Hussain Tanvir
 *  Under ISC License
 */ /*
 *  jQuery Dropdown Datepicker - v1.0.0
 *  A simple, customisable date select plugin
 *
 *  Made by Md Shafkat Hussain Tanvir
 *  Under ISC License
 */ (function($, window1, document1, undefined) {
    'use strict';
    // Create the defaults once
    var pluginName = 'dropdownDatepicker', pluginDefaults = {
        defaultDate: null,
        defaultDateFormat: 'yyyy-mm-dd',
        displayFormat: 'ymd',
        submitFormat: 'yyyy-mm-dd',
        minAge: null,
        maxAge: null,
        minYear: null,
        maxYear: null,
        minDate: null,
        maxDate: null,
        allowPast: true,
        allowFuture: true,
        submitFieldName: 'date',
        wrapperClass: 'date-dropdowns',
        dropdownClass: null,
        daySuffixes: true,
        monthSuffixes: true,
        monthFormat: 'long',
        required: false,
        dayLabel: 'Day',
        monthLabel: 'Month',
        yearLabel: 'Year',
        sortYear: 'desc',
        monthLongValues: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthShortValues: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        initialDayMonthYearValues: [
            'Day',
            'Month',
            'Year'
        ],
        daySuffixValues: [
            'st',
            'nd',
            'rd',
            'th'
        ],
        onDayChange: null,
        onMonthChange: null,
        onYearChange: null
    };
    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element; // Element handle
        this.$element = $(element); // jQuery element handle
        this.config = $.extend({}, pluginDefaults, options); // Plugin options
        this.internals = {
            objectRefs: {}
        };
        this.init();
        return this;
    }
    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        /**
         * Initialise the plugin
         */ init: function() {
            // this.checkForDuplicateElement();
            this.setInternalVariables();
            this.setupMarkup();
            this.buildDropdowns();
            this.attachDropdowns();
            this.bindChangeEvent();
            if (this.config.defaultDate) {
                if (isNaN(Date.parse(this.config.defaultDate)) === true) return;
                // if past date is disallowed and default is a past date then no default date is selected
                if (!this.config.allowPast && new Date().getTime() > new Date(this.config.defaultDate).getTime()) return;
                // if future date is disallowed and default is a future date then no default date is selected
                if (!this.config.allowFuture && new Date().getTime() < new Date(this.config.defaultDate).getTime()) return;
                this.populateDefaultDate();
            }
        },
        // set internal variables
        setInternalVariables: function() {
            var date = new Date();
            this.internals.currentDay = date.getDate();
            this.internals.currentMonth = date.getMonth() + 1;
            this.internals.currentYear = date.getFullYear();
        },
        // setup html markup
        setupMarkup: function() {
            var wrapper, hiddenField;
            if (this.element.tagName.toLowerCase() === 'input') {
                if (!this.config.defaultDate) this.config.defaultDate = this.element.value;
                // Configure the input element and wrap
                hiddenField = this.$element.wrap('<div class="' + this.config.wrapperClass + '"></div>');
                // hiddenField = this.$element.attr('type', 'hidden')
                // .wrap('<div class="' + this.config.wrapperClass + '"></div>');
                var customFieldNameProvided = this.config.submitFieldName !== pluginDefaults.submitFieldName, fieldHasName = this.element.hasAttribute('name');
                // Set the name attribute of the submit input
                if (!fieldHasName && !customFieldNameProvided) this.$element.attr('name', pluginDefaults.submitFieldName);
                else if (customFieldNameProvided) this.$element.attr('name', this.config.submitFieldName);
                wrapper = this.$element.parent();
            } else {
                // Build a hidden input and set this.$element as the wrapper
                hiddenField = $('<input/>', {
                    type: 'hidden',
                    name: this.config.submitFieldName
                });
                this.$element.append(hiddenField).addClass(this.config.wrapperClass);
                wrapper = this.$element;
            }
            // Store a reference to the wrapper and hidden field elements for later use
            this.internals.objectRefs.pluginWrapper = wrapper;
            this.internals.objectRefs.hiddenField = hiddenField;
            return true;
        },
        buildDropdowns: function() {
            var $dayDropdown, $dayOptions, $monthDropdown, $monthOptions, $yearDropdown, $yearOptions;
            Plugin.message = {
                day: this.config.initialDayMonthYearValues[0],
                month: this.config.initialDayMonthYearValues[1],
                year: this.config.initialDayMonthYearValues[2]
            };
            var parts = this.processDefaultDate();
            // Build the day dropdown element
            $dayDropdown = this.buildBaseDropdown('day');
            $dayOptions = this.buildDayOptions(parts[1], parts[2]);
            $dayDropdown = this.addOptionsToDropdown($dayDropdown, $dayOptions);
            this.internals.objectRefs.dayDropdown = $dayDropdown;
            $monthDropdown = this.buildBaseDropdown('month');
            $monthOptions = this.buildMonthOptions(parts[2]);
            $monthDropdown = this.addOptionsToDropdown($monthDropdown, $monthOptions);
            this.internals.objectRefs.monthDropdown = $monthDropdown;
            $yearDropdown = this.buildBaseDropdown('year');
            $yearOptions = this.buildYearOptions();
            $yearDropdown = this.addOptionsToDropdown($yearDropdown, $yearOptions);
            this.internals.objectRefs.yearDropdown = $yearDropdown;
            return true;
        },
        attachDropdowns: function() {
            var $element = this.internals.objectRefs.pluginWrapper, $daySelect = this.internals.objectRefs.dayDropdown, $monthSelect = this.internals.objectRefs.monthDropdown, $yearSelect = this.internals.objectRefs.yearDropdown;
            switch(this.config.displayFormat){
                case 'mdy':
                    $element.append($monthSelect, $daySelect, $yearSelect);
                    break;
                case 'ymd':
                    $element.append($yearSelect, $monthSelect, $daySelect);
                    break;
                case 'dmy':
                default:
                    $element.append($daySelect, $monthSelect, $yearSelect);
                    break;
            }
            return true;
        },
        bindChangeEvent: function() {
            var $daySelect = this.internals.objectRefs.dayDropdown, $monthSelect = this.internals.objectRefs.monthDropdown, $yearSelect = this.internals.objectRefs.yearDropdown, pluginHandle = this, objectRefs = this.internals.objectRefs, $that = this;
            objectRefs.pluginWrapper.on('change', 'select', function() {
                var day = $daySelect.val(), month = $monthSelect.val(), year = $yearSelect.val(), invalidDay, invalidMonth, newDate, $monthOptions, $monthDropdown, $dayOptions, $dayDropdown;
                // Find out whether the change has made the date invalid (e.g. 31st Feb)
                // alert('ok');
                if ($(this).hasClass('day')) {
                    if (typeof $that.config.onDayChange === 'function') $that.config.onDayChange(day, month, year);
                }
                if ($(this).hasClass('year')) {
                    $that.clearOptions($monthSelect);
                    $monthOptions = $that.buildMonthOptions(year);
                    $monthDropdown = $that.addOptionsToDropdown($monthSelect, $monthOptions);
                    $that.internals.objectRefs.monthDropdown = $monthDropdown;
                    month = null;
                    $that.clearOptions($daySelect);
                    $dayOptions = $that.buildDayOptions(month, year);
                    $dayDropdown = $that.addOptionsToDropdown($daySelect, $dayOptions);
                    $that.internals.objectRefs.dayDropdown = $dayDropdown;
                    if (typeof $that.config.onYearChange === 'function') $that.config.onYearChange(day, month, year);
                }
                if ($(this).hasClass('month')) {
                    $that.clearOptions($daySelect);
                    $dayOptions = $that.buildDayOptions(month, year);
                    $dayDropdown = $that.addOptionsToDropdown($daySelect, $dayOptions);
                    $that.internals.objectRefs.dayDropdown = $dayDropdown;
                    if (typeof $that.config.onMonthChange === 'function') $that.config.onMonthChange(day, month, year);
                }
                if (typeof $that.config.onChange === 'function') $that.config.onChange(day, month, year);
                // Empty the hidden field after each change
                objectRefs.hiddenField.val('');
                // Only format the submit date if a full date has been selected
                if (!invalidDay && !invalidMonth && day * month * year !== 0) {
                    newDate = pluginHandle.formatSubmitDate(day, month, year);
                    objectRefs.hiddenField.val(newDate);
                }
                objectRefs.hiddenField.change();
            });
        },
        buildBaseDropdown: function(type) {
            var classString = type;
            if (this.config.dropdownClass) classString += ' ' + this.config.dropdownClass;
            return $('<select></select>', {
                class: classString,
                name: this.config.submitFieldName + '_[' + type + ']',
                required: this.config.required
            });
        },
        buildDayOptions: function(month, year) {
            var day, start1 = 1, start2 = 10, end1 = 9, end2 = 31, options = [], option = document1.createElement('option');
            month = parseInt(month);
            year = parseInt(year);
            if (!this.config.allowPast && year === this.internals.currentYear && month === this.internals.currentMonth && start1 < this.internals.currentDay) start1 = this.internals.currentDay;
            if (this.config.maxAge != null) {
                if (year === this.internals.currentYear - this.config.maxAge && month === this.internals.currentMonth) start1 = this.internals.currentDay;
            }
            if (this.config.minDate !== null && new Date(this.config.minDate).getFullYear() === year && new Date(this.config.minDate).getMonth() + 1 === month) start1 = start1 < new Date(this.config.minDate).getDate() ? new Date(this.config.minDate).getDate() : start1;
            if (start2 < start1) start2 = start1;
            var numDaysInMonth = new Date(year, month, 0).getDate();
            if (end2 > numDaysInMonth) end2 = numDaysInMonth;
            if (!this.config.allowFuture && year === this.internals.currentYear && month === this.internals.currentMonth && end2 > this.internals.currentDay) end2 = this.internals.currentDay;
            if (this.config.minAge != null) {
                if (year === this.internals.currentYear - this.config.minAge && month === this.internals.currentMonth) end2 = this.internals.currentDay;
            }
            if (this.config.maxDate !== null && new Date(this.config.maxDate).getFullYear() === year && new Date(this.config.maxDate).getMonth() + 1 === month) end2 = end2 > new Date(this.config.maxDate).getDate() ? new Date(this.config.maxDate).getDate() : end2;
            if (end1 > start2) start2 = end1;
            if (start2 > end2) end2 = start2;
            if (this.config.dayLabel) {
                option.setAttribute('value', '');
                option.appendChild(document1.createTextNode(this.config.dayLabel));
                options.push(option);
            }
            // Days 1-9
            for(var i = start1; i <= end1; i++){
                if (this.config.daySuffixes) day = i + this.getSuffix(i);
                else day = '0' + i;
                option = document1.createElement('option');
                option.setAttribute('value', '0' + i);
                option.appendChild(document1.createTextNode(day));
                options.push(option);
            }
            // Days 10-31
            for(var j = start2; j <= end2; j++){
                day = j;
                if (this.config.daySuffixes) day = j + this.getSuffix(j);
                option = document1.createElement('option');
                option.setAttribute('value', j);
                option.appendChild(document1.createTextNode(day));
                options.push(option);
            }
            return options;
        },
        buildMonthOptions: function(year) {
            var start = 1, end = 12, options = [], option = document1.createElement('option');
            year = parseInt(year);
            if (!this.config.allowPast && year === this.internals.currentYear) start = this.internals.currentMonth;
            if (!this.config.allowFuture && year === this.internals.currentYear) end = this.internals.currentMonth;
            if (this.config.minAge != null) {
                if (year === this.internals.currentYear - this.config.minAge) end = this.internals.currentMonth;
            }
            if (this.config.maxAge != null) {
                if (year === this.internals.currentYear - this.config.maxAge) start = this.internals.currentMonth;
            }
            if (this.config.minDate !== null && new Date(this.config.minDate).getFullYear() === year) start = start < new Date(this.config.minDate).getMonth() + 1 ? new Date(this.config.minDate).getMonth() + 1 : start;
            if (this.config.maxDate !== null && new Date(this.config.maxDate).getFullYear() === year) end = end > new Date(this.config.maxDate).getMonth() + 1 ? new Date(this.config.maxDate).getMonth() + 1 : end;
            if (this.config.monthLabel) {
                option.setAttribute('value', '');
                option.appendChild(document1.createTextNode(this.config.monthLabel));
                options.push(option);
            }
            // Populate the month values
            for(var monthNo = start; monthNo <= end; monthNo++){
                var month;
                switch(this.config.monthFormat){
                    case 'short':
                        month = this.config.monthShortValues[monthNo - 1];
                        break;
                    case 'long':
                        month = this.config.monthLongValues[monthNo - 1];
                        break;
                    case 'numeric':
                        month = monthNo;
                        if (this.config.monthSuffixes) month += this.getSuffix(monthNo);
                        break;
                }
                if (monthNo < 10) monthNo = '0' + monthNo;
                option = document1.createElement('option');
                option.setAttribute('value', monthNo);
                option.appendChild(document1.createTextNode(month));
                options.push(option);
            }
            return options;
        },
        buildYearOptions: function() {
            var minYear = this.config.minYear, maxYear = this.config.maxYear, options = [], option = document1.createElement('option');
            if (this.config.yearLabel) {
                option.setAttribute('value', '');
                option.appendChild(document1.createTextNode(this.config.yearLabel));
                options.push(option);
            }
            if (this.config.minAge != null) maxYear = this.internals.currentYear - this.config.minAge;
            if (this.config.maxAge != null) minYear = this.internals.currentYear - this.config.maxAge;
            if (!minYear) minYear = this.config.allowPast ? 1970 : this.internals.currentYear;
            else minYear = this.config.allowPast ? minYear : this.internals.currentYear;
            if (this.config.minDate !== null) minYear = new Date(this.config.minDate).getFullYear();
            if (!maxYear) maxYear = this.internals.currentYear + 20;
            if (!this.config.allowFuture) maxYear = this.internals.currentYear;
            if (this.config.maxDate !== null) maxYear = new Date(this.config.maxDate).getFullYear();
            var i;
            if (this.config.sortYear === 'desc') for(i = maxYear; i >= minYear; i--){
                option = document1.createElement('option');
                option.setAttribute('value', i);
                option.appendChild(document1.createTextNode(i));
                options.push(option);
            }
            else for(i = minYear; i <= maxYear; i++){
                option = document1.createElement('option');
                option.setAttribute('value', i);
                option.appendChild(document1.createTextNode(i));
                options.push(option);
            }
            return options;
        },
        addOptionsToDropdown: function(dropdown, options) {
            for(var index = 0; index < options.length; index++)dropdown.append(options[index]);
            return dropdown;
        },
        clearOptions: function(parent) {
            parent.children('option').each(function() {
                $(this).remove();
            });
        },
        processDefaultDate: function() {
            var date = this.config.defaultDate, parts = [], day = '', month = '', year = '';
            switch(this.config.defaultDateFormat){
                case 'yyyy-mm-dd':
                default:
                    parts = date.split('-');
                    day = parts[2];
                    month = parts[1];
                    year = parts[0];
                    break;
                case 'dd/mm/yyyy':
                    parts = date.split('/');
                    day = parts[0];
                    month = parts[1];
                    year = parts[2];
                    break;
                case 'mm/dd/yyyy':
                    parts = date.split('/');
                    day = parts[1];
                    month = parts[0];
                    year = parts[2];
                    break;
                case 'unix':
                    parts = new Date();
                    parts.setTime(date * 1000);
                    day = parts.getDate() + '';
                    month = parts.getMonth() + 1 + '';
                    year = parts.getFullYear();
                    if (day.length < 2) day = '0' + day;
                    if (month.length < 2) month = '0' + month;
                    break;
            }
            return [
                day,
                month,
                year
            ];
        },
        populateDefaultDate: function() {
            var date = this.config.defaultDate;
            var parts = this.processDefaultDate();
            // Set the values on the dropdowns
            this.internals.objectRefs.dayDropdown.val(parts[0]);
            this.internals.objectRefs.monthDropdown.val(parts[1]);
            this.internals.objectRefs.yearDropdown.val(parts[2]);
            this.internals.objectRefs.hiddenField.val(date);
            return true;
        },
        getSuffix: function(number) {
            var suffix = '';
            var st = this.config.daySuffixValues[0];
            var nd = this.config.daySuffixValues[1];
            var rd = this.config.daySuffixValues[2];
            var th = this.config.daySuffixValues[3];
            switch(number % 10){
                case 1:
                    suffix = number % 100 === 11 ? th : st;
                    break;
                case 2:
                    suffix = number % 100 === 12 ? th : nd;
                    break;
                case 3:
                    suffix = number % 100 === 13 ? th : rd;
                    break;
                default:
                    suffix = th;
                    break;
            }
            return suffix;
        },
        formatSubmitDate: function(day, month, year) {
            var formattedDate, _date;
            switch(this.config.submitFormat){
                case 'unix':
                    _date = new Date();
                    _date.setDate(day);
                    _date.setMonth(month - 1);
                    _date.setYear(year);
                    formattedDate = Math.round(_date.getTime() / 1000);
                    break;
                default:
                    formattedDate = this.config.submitFormat.replace('dd', day).replace('mm', month).replace('yyyy', year);
                    break;
            }
            return formattedDate;
        },
        destroy: function() {
            var wrapperClass = this.config.wrapperClass;
            if (this.$element.hasClass(wrapperClass)) // this.$element.empty();
            this.$element.removeData('plugin_' + pluginName);
            else {
                var $parent = this.$element.parent(), $select = $parent.find('select');
                this.$element.removeData('plugin_' + pluginName);
                this.$element.unwrap();
                $select.remove();
            }
        }
    });
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function(options) {
        this.each(function() {
            if (typeof options === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var plugin = $.data(this, 'plugin_' + pluginName);
                if (typeof plugin === 'undefined') {
                    $.error('Please initialize the plugin before calling this method.');
                    return false;
                }
                plugin[options].apply(plugin, args);
            } else if (!$.data(this, 'plugin_' + pluginName)) $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        });
        // chain jQuery functions
        return this;
    };
})(jQuery, window, document);


parcelRequire("3MUFr");



var $f2WZf = parcelRequire("f2WZf");

var $8lWDI = parcelRequire("8lWDI");

var $7JB23 = parcelRequire("7JB23");

var $k4QTz = parcelRequire("k4QTz");
var $8bce9c5f32149532$exports = {};
$8bce9c5f32149532$exports = JSON.parse('{"moments":[{"moment":"Anders (Hieronder zelf schrijven)"},{"moment":"Jij & Ik"},{"moment":"Eerste kus"},{"moment":"Toen de sterren op \xe9\xe9n lijn stonden"},{"moment":"Waar het allemaal begon"},{"moment":"Liefde onder de sterren"},{"moment":"Toen we trouwden"},{"moment":"Een ster werd geboren die nacht"},{"moment":"Sterrenhemel tijdens je geboorte"},{"moment":"De nacht waarin jij ter wereld kwam"},{"moment":"Toen ik geboren ben"},{"moment":"Toen de vonk oversloeg"},{"moment":"Het moment waarop we \'ja\' zeiden"},{"moment":"Ons huis onder de sterren"},{"moment":"When the stars aligned"},{"moment":"You & Me"},{"moment":"Where it happened"},{"moment":"Where it all began"},{"moment":"First date"},{"moment":"When we met"},{"moment":"When it all started"},{"moment":"First Kiss"},{"moment":"When she said yes"},{"moment":"When he said yes"},{"moment":"When I was born"}]}');


class $1810d162d5962663$export$c019608e5b5bb4cb {
    _schema = {};
    _query = {
        size: "posterSize",
        frame: "posterFrame",
        giftwrap: "posterGiftwrapSelect",
        StarsMoment: "StarsMoment",
        StarsLocation: "StarsLocation",
        StarsReadableDate: "StarsReadableDate",
        StarsSubtitle: "StarsSubtitle",
        StarsDate: "StarsDate",
        StarsTime: "StarsTime",
        StarsLat: "StarsLat",
        StarsLong: "StarsLong",
        songFontStyle: "SongFontStyle",
        printType: "PrintType",
        aluminiumColor: "AluminiumColor",
        previousCartItemId: "previousCartItemId"
    };
    _options = {
        settingsPanel: "map",
        posterSize: "small",
        posterFrame: "black",
        acrylBlock: "no-block",
        ShowMilkyWay: true,
        ShowConstellations: true,
        ShowGlobe: false,
        ShowTime: false,
        PosterColorNumber: "1",
        PosterBGColor: "light",
        PosterBorder: "border"
    };
    constructor(){
        this._searchParams = new URLSearchParams(window.location.search);
        // Flips the queries key and value
        this._queryMap = Object.assign({}, ...Object.entries(this._query).map(([a, b])=>({
                [b]: a
            })));
    }
    checkEncodeURI(str) {
        return /\%/i.test(str);
    }
    get(key, defaultValue = null, defaultType = null) {
        let type = this._schema[key] || defaultType;
        let value = this._getOption(key) || defaultValue;
        if (!type) return value || defaultValue;
        if (type === "object" && value) {
            if (this.checkEncodeURI(value)) value = decodeURI(value);
            return JSON.parse(value);
        }
        if (type === "split" && value) return value.replace("[", "").replace("]", "").split(",");
        if (type === "bool") {
            if (value === "true" || value === "1" || value === true) return true;
            if (value === "false" || value === "0" || value === false) return false;
            return this._options[key];
        }
        return value;
    }
    _getOption(key) {
        let value;
        let altKey = this._queryMap[key];
        // Try GET parameters
        value = this._searchParams.get(key);
        if (value !== null) return value;
        // Try GET parameters with custom name
        value = this._searchParams.get(altKey);
        if (value !== null) return value;
        // Try Local storage
        value = localStorage.getItem(key);
        if (value !== null) return value;
        // Return default value
        return this._options[key] || this._options[altKey];
    }
    _getQuery() {}
    all() {
        return this._options;
    }
}



var $47G0t = parcelRequire("47G0t");

var $6Kc1e = parcelRequire("6Kc1e");

var $gF0Ex = parcelRequire("gF0Ex");

var $1OR0H = parcelRequire("1OR0H");

var $8UUYp = parcelRequire("8UUYp");

var $5t1He = parcelRequire("5t1He");

var $gtTze = parcelRequire("gtTze");
(0, (/*@__PURE__*/$parcel$interopDefault($f2WZf))).accessToken = "pk.eyJ1Ijoid2FsbC0yMy02IiwiYSI6ImNsZW8ycTY4NTA1M3MzcW80aXJhbjhiZ2kifQ.-fjW3lvFwnuDnt5gfe4gBw";
let $991b8b8ca8b4a964$var$woocommerceUrl = "https://wallable.nl";
const $991b8b8ca8b4a964$var$apiBase = "";
const $991b8b8ca8b4a964$var$options = new (0, $1810d162d5962663$export$c019608e5b5bb4cb)();
let $991b8b8ca8b4a964$var$marketContext;
let $991b8b8ca8b4a964$var$t = (key)=>key;
let $991b8b8ca8b4a964$var$formatCurrency = (value)=>`\u{20AC}${Number(value).toFixed(2).replace(".", ",")}`;
let $991b8b8ca8b4a964$var$formatLocaleDate = (value)=>String(value);
const $991b8b8ca8b4a964$var$i18nReady = (0, $5t1He.initializeI18n)().then((i18n)=>{
    ({ marketContext: $991b8b8ca8b4a964$var$marketContext, t: $991b8b8ca8b4a964$var$t, formatCurrency: $991b8b8ca8b4a964$var$formatCurrency, formatDate: $991b8b8ca8b4a964$var$formatLocaleDate } = i18n);
    $991b8b8ca8b4a964$var$woocommerceUrl = $991b8b8ca8b4a964$var$marketContext.services.woocommerceBaseUrl;
});
const $991b8b8ca8b4a964$var$PosterColors = {
    1: {
        background: "#000000",
        starmap: "#000000",
        milkyway: "#ffffff",
        text: "#000000"
    },
    2: {
        background: "#8c031c",
        starmap: "#8c031c",
        milkyway: "#ffffff",
        text: "#4e0310"
    },
    3: {
        background: "#000d4f",
        starmap: "#000d4f",
        milkyway: "#ffffff",
        text: "#000d4f"
    },
    4: {
        background: "#00213f",
        starmap: "#00213f",
        milkyway: "#8EE8E3",
        text: "#00213f"
    },
    5: {
        background: "linear-gradient(to right bottom, rgba(41 76 198 / 1), rgba(35 60 142 / 1), rgba(4 14 43 / 1))",
        starmap: "#16308E",
        milkyway: "#ffffff",
        text: "#09184d"
    },
    6: {
        background: "#1f0252",
        starmap: "#1f0252",
        milkyway: "#ffffff",
        text: "#1f0252"
    },
    7: {
        background: "#867B6B",
        starmap: "#5f5444",
        milkyway: "#ffffff",
        text: "#5f5444"
    }
};
let $991b8b8ca8b4a964$var$PosterPreviewImage;
let $991b8b8ca8b4a964$var$ShowMobileSettingPanel = false;
let $991b8b8ca8b4a964$var$PrintTypeSelected = true;
const $991b8b8ca8b4a964$var$BuilderName = $("body").attr("id");
let $991b8b8ca8b4a964$var$SettingsPanel = $991b8b8ca8b4a964$var$options.get("settingsPanel", "map");
let $991b8b8ca8b4a964$var$PosterSize = $991b8b8ca8b4a964$var$options.get("posterSize", "small");
let $991b8b8ca8b4a964$var$PosterFrame = $991b8b8ca8b4a964$var$options.get("posterFrame", "black");
let $991b8b8ca8b4a964$var$AcrylBlock = $991b8b8ca8b4a964$var$options.get("acrylBlock", "black");
let $991b8b8ca8b4a964$var$AluminiumColor = $991b8b8ca8b4a964$var$options.get("aluminiumColor", "silver");
let $991b8b8ca8b4a964$var$PosterFontStyle = $991b8b8ca8b4a964$var$options.get("SongFontStyle", "modern");
let $991b8b8ca8b4a964$var$PrintType = $991b8b8ca8b4a964$var$options.get("printType", "paper");
let $991b8b8ca8b4a964$var$StarsMoment = $991b8b8ca8b4a964$var$options.get("StarsMoment");
let $991b8b8ca8b4a964$var$StarsDate = $991b8b8ca8b4a964$var$options.get("StarsDate", "2020-02-17");
let $991b8b8ca8b4a964$var$StarsTime = $991b8b8ca8b4a964$var$options.get("StarsTime", "22:30");
let $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$options.get("StarsReadableDate");
let $991b8b8ca8b4a964$var$StarsLocation = $991b8b8ca8b4a964$var$options.get("StarsLocation");
let $991b8b8ca8b4a964$var$StarsSubtitle = $991b8b8ca8b4a964$var$options.get("StarsSubtitle");
let $991b8b8ca8b4a964$var$StarsLat = $991b8b8ca8b4a964$var$options.get("StarsLat", "52.08");
let $991b8b8ca8b4a964$var$StarsLong = $991b8b8ca8b4a964$var$options.get("StarsLong", "4.32");
let $991b8b8ca8b4a964$var$ShowMilkyWay = $991b8b8ca8b4a964$var$options.get("ShowMilkyWay", true, "bool");
let $991b8b8ca8b4a964$var$ShowConstellations = $991b8b8ca8b4a964$var$options.get("ShowConstellations", true, "bool");
let $991b8b8ca8b4a964$var$ShowGlobe = $991b8b8ca8b4a964$var$options.get("ShowGlobe", false, "bool");
let $991b8b8ca8b4a964$var$ShowTime = $991b8b8ca8b4a964$var$options.get("ShowTime", true, "bool");
let $991b8b8ca8b4a964$var$PosterColorNumber = $991b8b8ca8b4a964$var$options.get("PosterColorNumber", "1");
let $991b8b8ca8b4a964$var$PosterBGColor = $991b8b8ca8b4a964$var$options.get("PosterBGColor", "light");
let $991b8b8ca8b4a964$var$PosterBorder = $991b8b8ca8b4a964$var$options.get("PosterBorder", "border");
$991b8b8ca8b4a964$var$StarsLat = parseFloat($991b8b8ca8b4a964$var$StarsLat);
$991b8b8ca8b4a964$var$StarsLong = parseFloat($991b8b8ca8b4a964$var$StarsLong);
const $991b8b8ca8b4a964$var$MomentSelector = $(".js-moments");
const $991b8b8ca8b4a964$var$MomentInput = $("#moment-input");
const $991b8b8ca8b4a964$var$MomentLabel = $(".labels .moment");
const $991b8b8ca8b4a964$var$CoordinatesInput = $("#coordinates-input");
const $991b8b8ca8b4a964$var$CoordinatesLabel = $(".labels .coordinates");
const $991b8b8ca8b4a964$var$SubtitleInput = $("#subtitle-input");
const $991b8b8ca8b4a964$var$SubtitleLabel = $(".labels .subtitle");
const $991b8b8ca8b4a964$var$Subtitle2Input = $("#subtitle-2-input");
const $991b8b8ca8b4a964$var$Subtitle2Label = $(".labels .subtitle-2");
const $991b8b8ca8b4a964$var$TimePicker = $("#timepicker");
const $991b8b8ca8b4a964$var$TimeToggle = $("#timeToggle");
const $991b8b8ca8b4a964$var$PosterWrapper = $(".map-wrapper");
const $991b8b8ca8b4a964$var$PosterSizeSelect = $(".js-poster-size");
const $991b8b8ca8b4a964$var$PosterFrameSelect = $(".js-poster-frame");
const $991b8b8ca8b4a964$var$AcrylBlockSelect = $(".js-acryl-block");
const $991b8b8ca8b4a964$var$PrintTypeSelect = $(".js-print-type");
const $991b8b8ca8b4a964$var$PosterGiftwrapSelect = $(".js-giftwrap");
const $991b8b8ca8b4a964$var$GiftCardSelect = $(".js-giftcard");
let $991b8b8ca8b4a964$var$GiftCardText = "";
const $991b8b8ca8b4a964$var$debugReporter = (0, $1OR0H.DebugReporter)({
    ajaxUrl: $991b8b8ca8b4a964$var$apiBase + "/wp-json/wallable/v1/client-diagnostics",
    containerSelector: ".js-notifications",
    shouldShow: ({ meta: meta })=>meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
    extraContext: ()=>({
            builder: $("body").attr("id")
        })
}).init();
// Load saved poster after locale and market configuration are available.
$991b8b8ca8b4a964$var$i18nReady.then(()=>{
    $991b8b8ca8b4a964$var$getSavedPoster();
    $991b8b8ca8b4a964$var$toggleProductionEnv();
    $991b8b8ca8b4a964$var$calculatePosterPrice();
    $991b8b8ca8b4a964$var$resizePosterWrapper();
    $991b8b8ca8b4a964$var$toggleClearIcons();
    $991b8b8ca8b4a964$var$toggleStarmapOptions();
    $991b8b8ca8b4a964$var$setPreviewMode();
});
// For dismissing panel if previewing from shopping cart
function $991b8b8ca8b4a964$var$setPreviewMode() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preview")) $991b8b8ca8b4a964$var$dismissSettingsPanel();
}
function $991b8b8ca8b4a964$var$waitForCelestial() {
    return new Promise((resolve, reject)=>{
        if (window.Celestial) return resolve(window.Celestial);
        const t = setInterval(()=>{
            if (window.Celestial) {
                clearInterval(t);
                resolve(window.Celestial);
            }
        }, 20);
        setTimeout(()=>{
            clearInterval(t);
            reject(new Error("Celestial timeout"));
        }, 5000);
    });
}
$(async ()=>{
    const Celestial1 = await $991b8b8ca8b4a964$var$waitForCelestial();
    // Celestial stuff
    Celestial1.display({
        width: 680,
        projection: "airy",
        container: "star-map",
        geopos: [
            $991b8b8ca8b4a964$var$StarsLat,
            $991b8b8ca8b4a964$var$StarsLong
        ],
        disableAnimations: $991b8b8ca8b4a964$var$BuilderName === "PrintApp" ? true : false,
        datapath: "https://ofrohn.github.io/data/",
        controls: false,
        background: {
            fill: $991b8b8ca8b4a964$var$PosterColors[$991b8b8ca8b4a964$var$PosterColorNumber].starmap,
            opacity: 1,
            stroke: "none",
            width: 0.1
        },
        stars: {
            show: true,
            limit: 6,
            names: false
        },
        constellations: {
            names: false,
            lines: $991b8b8ca8b4a964$var$ShowConstellations
        },
        planets: {
            names: false
        },
        dsos: {
            names: false,
            show: false
        },
        mw: {
            show: $991b8b8ca8b4a964$var$ShowMilkyWay,
            style: {
                fill: $991b8b8ca8b4a964$var$PosterColors[$991b8b8ca8b4a964$var$PosterColorNumber].milkyway,
                opacity: 0.15
            }
        },
        lines: {
            graticule: {
                show: $991b8b8ca8b4a964$var$ShowGlobe,
                stroke: "#ffffff",
                width: 0.6,
                opacity: 0.8,
                lon: {
                    pos: [
                        ""
                    ],
                    fill: "#eee"
                },
                lat: {
                    pos: [
                        ""
                    ],
                    fill: "#eee"
                }
            },
            equatorial: {
                show: false
            },
            ecliptic: {
                show: false
            },
            galactic: {
                show: false
            },
            supergalactic: {
                show: false
            }
        }
    });
    Celestial1.skyview({
        date: $991b8b8ca8b4a964$var$getCelestialDate(),
        location: [
            $991b8b8ca8b4a964$var$StarsLat,
            $991b8b8ca8b4a964$var$StarsLong
        ],
        timezone: 60
    });
    if ($991b8b8ca8b4a964$var$BuilderName !== "PrintApp") return;
    window.status = "mapbox-loading";
    await new Promise((r)=>setTimeout(r, 5000));
    window.status = "mapbox-ready";
});
$(document).ready(async ()=>{
    await $991b8b8ca8b4a964$var$i18nReady;
    setTimeout(()=>{
        $(".anim-wrapper").removeClass("hidden");
        $(".loading-wrapper").remove();
        $991b8b8ca8b4a964$var$styleMilkyWay();
        $991b8b8ca8b4a964$var$applyColors($991b8b8ca8b4a964$var$PosterColorNumber);
        $991b8b8ca8b4a964$var$setBGColor();
        $991b8b8ca8b4a964$var$toggleBorder();
        $991b8b8ca8b4a964$var$scaleFontSize();
        $991b8b8ca8b4a964$var$setPrintType($991b8b8ca8b4a964$var$PrintType);
    }, "500");
});
// Geocoder stuff
let $991b8b8ca8b4a964$var$geocoder;
$991b8b8ca8b4a964$var$i18nReady.then(()=>{
    $991b8b8ca8b4a964$var$geocoder = new (0, (/*@__PURE__*/$parcel$interopDefault($8lWDI)))({
        accessToken: (0, (/*@__PURE__*/$parcel$interopDefault($f2WZf))).accessToken,
        language: $991b8b8ca8b4a964$var$marketContext.locale.split("-")[0],
        placeholder: $991b8b8ca8b4a964$var$t("components.markerOptions.searchPlaceholder")
    });
    $991b8b8ca8b4a964$var$geocoder.addTo("#geocoder");
    $991b8b8ca8b4a964$var$geocoder.on("result", (e)=>{
        $991b8b8ca8b4a964$var$StarsLocation = $991b8b8ca8b4a964$var$formatCoordinates(e.result.center);
        $991b8b8ca8b4a964$var$StarsLat = e.result.center[1];
        $991b8b8ca8b4a964$var$StarsLong = e.result.center[0];
        Celestial.skyview({
            date: $991b8b8ca8b4a964$var$getCelestialDate(),
            location: [
                $991b8b8ca8b4a964$var$StarsLat,
                $991b8b8ca8b4a964$var$StarsLong
            ],
            timezone: 60
        });
    });
});
function $991b8b8ca8b4a964$var$formatCoordinates(lngLat) {
    function convertToDMS(deg) {
        const absolute = Math.abs(deg);
        const degrees = Math.floor(absolute);
        const minutes = Math.floor((absolute - degrees) * 60);
        const seconds = Math.round((absolute - degrees - minutes / 60) * 3600);
        return `${degrees}\xb0${minutes}'${seconds}"`;
    }
    const lng = lngLat[0];
    const lat = lngLat[1];
    const latDirection = lat >= 0 ? "N" : "S";
    const lngDirection = lng >= 0 ? "E" : "W";
    const Coordinates = `${convertToDMS(lat)}${latDirection} ${convertToDMS(lng)}${lngDirection}`;
    $991b8b8ca8b4a964$var$CoordinatesInput.val(Coordinates);
    $991b8b8ca8b4a964$var$CoordinatesLabel.html(Coordinates);
}
// For toggling starmap options
$(".js-toggle-starmap-option").on("click", function() {
    const toggle = $(this).data("starmap-option");
    switch(toggle){
        case "ShowMilkyWay":
            $991b8b8ca8b4a964$var$ShowMilkyWay = $991b8b8ca8b4a964$var$ShowMilkyWay === true ? false : true;
            break;
        case "ShowConstellations":
            $991b8b8ca8b4a964$var$ShowConstellations = $991b8b8ca8b4a964$var$ShowConstellations === true ? false : true;
            break;
        case "ShowGlobe":
            $991b8b8ca8b4a964$var$ShowGlobe = $991b8b8ca8b4a964$var$ShowGlobe === true ? false : true;
            break;
        default:
    }
    $991b8b8ca8b4a964$var$toggleStarmapOptions();
    $991b8b8ca8b4a964$var$styleMilkyWay();
});
function $991b8b8ca8b4a964$var$toggleStarmapOptions() {
    $('.js-toggle-starmap-option[data-starmap-option="ShowMilkyWay"]').toggleClass("active", $991b8b8ca8b4a964$var$ShowMilkyWay);
    $('.js-toggle-starmap-option[data-starmap-option="ShowGlobe"]').toggleClass("active", $991b8b8ca8b4a964$var$ShowGlobe);
    $('.js-toggle-starmap-option[data-starmap-option="ShowConstellations"]').toggleClass("active", $991b8b8ca8b4a964$var$ShowConstellations);
}
// For Starmap colors
function $991b8b8ca8b4a964$var$applyColors(colorNumber) {
    $(".poster-canvas .labels").css({
        color: $991b8b8ca8b4a964$var$PosterColors[colorNumber].text
    });
    Celestial.apply({
        background: {
            fill: $991b8b8ca8b4a964$var$PosterColors[colorNumber].starmap
        },
        mw: {
            style: {
                fill: $991b8b8ca8b4a964$var$PosterColors[colorNumber].milkyway,
                opacity: 0.25
            }
        }
    });
}
function $991b8b8ca8b4a964$var$loadColors() {
    // Target container where the elements will be appended
    const container = document.querySelector(".js-color-options-wrapper");
    // Loop through the PosterColors object and create elements
    Object.keys($991b8b8ca8b4a964$var$PosterColors).forEach((key)=>{
        const color = $991b8b8ca8b4a964$var$PosterColors[key];
        // Convert milkyway color to RGBA with opacity
        const milkywayRgba = $991b8b8ca8b4a964$var$hexToRgba(color.starmap, 0.9);
        // Create a div element
        const div = document.createElement("div");
        // Add classes and data attributes
        div.className = "js-style-option style-option color";
        div.dataset.style = key; // Set data-style="{array-index}"
        // Set background to a linear gradient
        div.style.background = `linear-gradient(35deg, ${milkywayRgba} 0%, ${milkywayRgba} 50%, ${color.starmap} 50%)`;
        // Append the div to the container
        container.appendChild(div);
    });
}
// Helper function to convert hex to RGBA with opacity
function $991b8b8ca8b4a964$var$hexToRgba(hex, opacity) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = bigint >> 16 & 255;
    const g = bigint >> 8 & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
function $991b8b8ca8b4a964$var$styleMilkyWay() {
    Celestial.apply({
        mw: {
            show: $991b8b8ca8b4a964$var$ShowMilkyWay
        },
        constellations: {
            lines: $991b8b8ca8b4a964$var$ShowConstellations
        },
        lines: {
            graticule: {
                show: $991b8b8ca8b4a964$var$ShowGlobe,
                stroke: "#ffffff",
                width: 0.6,
                opacity: 0.8,
                // grid values: "outline", "center", or [lat,...] specific position
                lon: {
                    pos: [
                        ""
                    ],
                    fill: "#eee"
                },
                // grid values: "outline", "center", or [lon,...] specific position
                lat: {
                    pos: [
                        ""
                    ],
                    fill: "#eee"
                }
            }
        }
    });
}
// For border
$(".js-border-option").on("click", function() {
    $991b8b8ca8b4a964$var$PosterBorder = $(this).data("border");
    $991b8b8ca8b4a964$var$toggleBorderSelect();
    $991b8b8ca8b4a964$var$toggleBorder();
    $991b8b8ca8b4a964$var$dismissSettingsPanel();
});
function $991b8b8ca8b4a964$var$toggleBorderSelect() {
    $(".js-border-option").removeClass("active");
    if ($991b8b8ca8b4a964$var$PosterBorder === "no-border") $('.js-border-option[data-border="no-border"]').addClass("active");
    else $('.js-border-option[data-border="border"]').addClass("active");
}
function $991b8b8ca8b4a964$var$toggleBorder() {
    let showBorder;
    showBorder = $991b8b8ca8b4a964$var$PosterBorder === "no-border" ? true : false;
    $(".frame").toggleClass("d-none", showBorder);
}
// For background color
$(".js-bg-option").on("click", function() {
    $991b8b8ca8b4a964$var$PosterBGColor = $(this).data("bg");
    $991b8b8ca8b4a964$var$toggleBGColorSelect();
    $991b8b8ca8b4a964$var$setBGColor();
    $991b8b8ca8b4a964$var$dismissSettingsPanel();
});
function $991b8b8ca8b4a964$var$toggleBGColorSelect() {
    $(".js-bg-option").removeClass("active");
    if ($991b8b8ca8b4a964$var$PosterBGColor === "dark") $('.js-bg-option[data-bg="dark"]').addClass("active");
    else $('.js-bg-option[data-bg="light"]').addClass("active");
}
function $991b8b8ca8b4a964$var$setBGColor() {
    const border = $(".frame");
    const labels = $(".poster-canvas .labels");
    const canvas = $(".poster-canvas");
    canvas.attr("data-bg", $991b8b8ca8b4a964$var$PosterBGColor);
    if ($991b8b8ca8b4a964$var$PosterBGColor === "dark") {
        canvas.css({
            background: $991b8b8ca8b4a964$var$PosterColors[$991b8b8ca8b4a964$var$PosterColorNumber].background
        });
        labels.css({
            color: "#ffffff"
        });
        border.css({
            "border-color": "#ffffff"
        });
        Celestial.apply({
            background: {
                stroke: "#ffffff",
                width: 3
            }
        });
    } else {
        canvas.removeAttr("style");
        labels.css({
            color: $991b8b8ca8b4a964$var$PosterColors[$991b8b8ca8b4a964$var$PosterColorNumber].text
        });
        border.css({
            "border-color": $991b8b8ca8b4a964$var$PosterColors[$991b8b8ca8b4a964$var$PosterColorNumber].text
        });
    }
}
// For date selection
$991b8b8ca8b4a964$var$i18nReady.then(()=>$("#datepicker").dropdownDatepicker({
        defaultDate: $991b8b8ca8b4a964$var$StarsDate,
        wrapperClass: "input-group mb-3",
        dropdownClass: "form-select",
        displayFormat: "ymd",
        yearLabel: $991b8b8ca8b4a964$var$t("starmap.date.year"),
        monthLabel: $991b8b8ca8b4a964$var$t("starmap.date.month"),
        dayLabel: $991b8b8ca8b4a964$var$t("starmap.date.day"),
        minYear: 1900,
        maxYear: 2030,
        monthLongValues: Array.from({
            length: 12
        }, (_, month)=>$991b8b8ca8b4a964$var$formatLocaleDate(new Date(2020, month, 1), {
                month: "long"
            })),
        daySuffixes: false,
        onChange: function(day, month, year) {
            if (day != null && month != null && year != null) {
                $991b8b8ca8b4a964$var$StarsDate = year + "-" + month + "-" + day;
                $991b8b8ca8b4a964$var$setReadableDateForPoster();
                Celestial.skyview({
                    date: $991b8b8ca8b4a964$var$getCelestialDate(),
                    location: [
                        $991b8b8ca8b4a964$var$StarsLat,
                        $991b8b8ca8b4a964$var$StarsLong
                    ],
                    timezone: 60
                });
            }
        }
    }));
function $991b8b8ca8b4a964$var$formatPosterDate(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    const FinalDay = day === 0 ? 1 : day;
    $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$formatLocaleDate(new Date(year, month - 1, FinalDay), {
        day: "numeric",
        month: "long",
        year: "numeric"
    });
    if ($991b8b8ca8b4a964$var$ShowTime) $991b8b8ca8b4a964$var$StarsReadableDate += `, ${$991b8b8ca8b4a964$var$StarsTime}`;
    return $991b8b8ca8b4a964$var$StarsReadableDate;
}
function $991b8b8ca8b4a964$var$setReadableDateForPoster() {
    $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$formatPosterDate($991b8b8ca8b4a964$var$StarsDate);
    $991b8b8ca8b4a964$var$SubtitleLabel.html($991b8b8ca8b4a964$var$StarsReadableDate);
    $991b8b8ca8b4a964$var$SubtitleInput.val($991b8b8ca8b4a964$var$StarsReadableDate);
}
// Time related stuff
function $991b8b8ca8b4a964$var$getCelestialDate() {
    const [y, m, d] = $991b8b8ca8b4a964$var$StarsDate.split("-").map(Number);
    const [hh, mm] = $991b8b8ca8b4a964$var$StarsTime.split(":").map(Number);
    return new Date(y, m - 1, d, hh, mm, 0, 0);
}
$991b8b8ca8b4a964$var$TimePicker.on("blur", function() {
    $991b8b8ca8b4a964$var$StarsTime = $(this).val();
    $991b8b8ca8b4a964$var$setReadableDateForPoster();
    Celestial.skyview({
        date: $991b8b8ca8b4a964$var$getCelestialDate(),
        location: [
            $991b8b8ca8b4a964$var$StarsLat,
            $991b8b8ca8b4a964$var$StarsLong
        ],
        timezone: 60
    });
});
$991b8b8ca8b4a964$var$TimeToggle.on("change", function() {
    $991b8b8ca8b4a964$var$ShowTime = $(this).is(":checked");
    $991b8b8ca8b4a964$var$setTimeToggle();
    $991b8b8ca8b4a964$var$setReadableDateForPoster();
    Celestial.skyview({
        date: $991b8b8ca8b4a964$var$getCelestialDate(),
        location: [
            $991b8b8ca8b4a964$var$StarsLat,
            $991b8b8ca8b4a964$var$StarsLong
        ],
        timezone: 60
    });
});
function $991b8b8ca8b4a964$var$setTimeToggle() {
    const TimeInfoPanel = $(".js-time-info");
    if ($991b8b8ca8b4a964$var$ShowTime) {
        $991b8b8ca8b4a964$var$TimePicker.prop("disabled", false);
        TimeInfoPanel.addClass("d-none");
        $991b8b8ca8b4a964$var$StarsTime = $991b8b8ca8b4a964$var$TimePicker.val();
    } else {
        $991b8b8ca8b4a964$var$TimePicker.prop("disabled", true);
        TimeInfoPanel.removeClass("d-none");
        $991b8b8ca8b4a964$var$StarsTime = "00:00";
    }
}
// Change poster color
$(".js-color-options-wrapper").on("click", ".js-style-option", function() {
    $991b8b8ca8b4a964$var$PosterColorNumber = $(this).attr("data-style");
    $991b8b8ca8b4a964$var$applyColors($991b8b8ca8b4a964$var$PosterColorNumber);
    $991b8b8ca8b4a964$var$setPosterColorSelection($991b8b8ca8b4a964$var$PosterColorNumber);
    $991b8b8ca8b4a964$var$setBGColor();
});
function $991b8b8ca8b4a964$var$setPosterColorSelection(colorNumber) {
    var selectedColor = $('.js-style-option[data-style="' + colorNumber + '"]');
    $(".js-style-option").removeClass("active");
    selectedColor.addClass("active");
    $991b8b8ca8b4a964$var$dismissSettingsPanel();
}
// Input listeners
$("input.form-control, textarea.form-control").on("input", function() {
    const posterLabel = this.dataset.posterLabel;
    if (!posterLabel) return;
    const value = $(this).val();
    $(".labels ." + posterLabel).html(value);
    if (posterLabel === "moment") $991b8b8ca8b4a964$var$scaleFontSize();
    $('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(value.length > 0);
});
$(".js-history-back").on("click", function() {
    history.back();
});
// Clear input fields
$(".js-clear-input").on("click", function() {
    const field = $(this).data("field-id");
    $('input.form-control[data-poster-label="' + field + '"], ' + 'textarea.form-control[data-poster-label="' + field + '"]').val("").trigger("input").trigger("focus");
});
// Check if field has value and show clear icon
function $991b8b8ca8b4a964$var$toggleClearIcons() {
    const inputFields = $("input.form-control");
    const textAreas = $("textarea.form-control");
    inputFields.each(function() {
        const inputValue = $(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $(this).data("poster-label");
            $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
    textAreas.each(function() {
        const inputValue = $(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $(this).data("poster-label");
            $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
}
// For scaling the font size
function $991b8b8ca8b4a964$var$scaleFontSize() {
    const minFontSize = 3.95;
    const maxFontSize = 6.45;
    const lineBreakThreshold = 3.96;
    const text = $(".js-poster-headline");
    const textWrapper = $(".headline-wrapper");
    const parentWidth = textWrapper[0].getBoundingClientRect().width;
    let fontSize = parseFloat(text.css("font-size")) / parseFloat(text.parent().css("font-size")); // Get current font size in em
    // Subpixel-precieze breedte van de tekst
    function getTextWidth() {
        return text[0].getBoundingClientRect().width;
    }
    // Check of tekst smaller is dan parent (met marge)
    function canGrow() {
        return getTextWidth() + 1 < parentWidth && fontSize < maxFontSize;
    }
    // Check of tekst te breed is
    function isTextTooWide() {
        return getTextWidth() > parentWidth - 1;
    }
    // Eerst verkleinen indien nodig
    while(isTextTooWide() && fontSize > minFontSize){
        fontSize -= 0.05;
        text.css("font-size", fontSize + "em");
    }
    // Daarna vergroten tot het nét past
    while(canGrow()){
        fontSize += 0.05;
        text.css("font-size", fontSize + "em");
    }
    // Als tekst erg klein wordt, laten wrappen
    if (fontSize <= lineBreakThreshold) {
        text.css("white-space", "pre-wrap");
        return; // Stop verdere schaalacties
    } else text.css("white-space", "nowrap");
}
// Changing poster
function $991b8b8ca8b4a964$var$setPosterSize(posterSize) {
    if ($991b8b8ca8b4a964$var$PrintType === "paper") $991b8b8ca8b4a964$var$PosterWrapper.removeClass().addClass("map-wrapper size-" + posterSize + " " + $991b8b8ca8b4a964$var$PrintType);
    else if ($991b8b8ca8b4a964$var$PrintType === "aluminium") $991b8b8ca8b4a964$var$PosterWrapper.removeClass().addClass("map-wrapper size-" + posterSize + " " + $991b8b8ca8b4a964$var$PrintType);
    else $991b8b8ca8b4a964$var$PosterWrapper.removeClass().addClass("map-wrapper size-small " + $991b8b8ca8b4a964$var$PrintType);
}
// Change poster font
$(".js-font-option").on("click", function() {
    $991b8b8ca8b4a964$var$PosterFontStyle = $(this).attr("data-font");
    $991b8b8ca8b4a964$var$setPosterFontSelection($991b8b8ca8b4a964$var$PosterFontStyle);
    $991b8b8ca8b4a964$var$setPosterFontStyle($991b8b8ca8b4a964$var$PosterFontStyle);
    $991b8b8ca8b4a964$var$dismissSettingsPanel();
    setTimeout(()=>{
        $991b8b8ca8b4a964$var$scaleFontSize();
    }, 50);
});
function $991b8b8ca8b4a964$var$setPosterFontStyle(font) {
    $(".poster-canvas .labels").removeClass("modern classic mono");
    $(".poster-canvas .labels").addClass(font);
}
function $991b8b8ca8b4a964$var$setPosterFontSelection(font) {
    var selectedFont = $('.js-font-option[data-font="' + font + '"]');
    $(".js-font-option").removeClass("active");
    selectedFont.addClass("active");
}
// Change poster size
$(".js-size-option").on("click", function() {
    $991b8b8ca8b4a964$var$PosterSize = $(this).attr("data-size");
    $991b8b8ca8b4a964$var$setPosterSize($991b8b8ca8b4a964$var$PosterSize);
    $991b8b8ca8b4a964$var$setSizeSelection($991b8b8ca8b4a964$var$PosterSize);
    $991b8b8ca8b4a964$var$calculatePosterPrice();
});
function $991b8b8ca8b4a964$var$setSizeSelection(posterSize) {
    let selectedSize = $('.js-toggle-for-material[data-material="' + $991b8b8ca8b4a964$var$PrintType + '"] .js-size-option[data-size="' + posterSize + '"]');
    $(".js-size-option").removeClass("active");
    selectedSize.addClass("active");
    if ($991b8b8ca8b4a964$var$PrintType !== "paper") return;
    let framePrice = 0;
    let frameNormalPrice = 0;
    switch(posterSize){
        case "small":
            framePrice = 15;
            frameNormalPrice = 21.95;
            break;
        case "medium":
            framePrice = 20;
            frameNormalPrice = 24.95;
            break;
        case "large":
            framePrice = 35;
            frameNormalPrice = 39.95;
            break;
        default:
            framePrice = 0;
            frameNormalPrice = 0;
    }
    // If extra-large, force no frame
    if (posterSize === "extra-large") {
        $991b8b8ca8b4a964$var$PosterFrame = "no-frame";
        $991b8b8ca8b4a964$var$setFrameSelection($991b8b8ca8b4a964$var$PosterFrame);
        $991b8b8ca8b4a964$var$setPosterFrame($991b8b8ca8b4a964$var$PosterFrame);
        $(".js-frame-option").addClass("disabled");
        $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
        $("small[frame-normal-price]").text("-");
        $("small[frame-price]").hide();
    } else {
        $(".js-frame-option").removeClass("disabled");
        $("small[frame-price]").show();
        $("small[frame-price]").text($991b8b8ca8b4a964$var$formatCurrency(framePrice));
        $("small[frame-normal-price]").text($991b8b8ca8b4a964$var$formatCurrency(frameNormalPrice));
        $(".js-frame-option").not('[data-frame="no-frame"]').attr("data-price", framePrice.toFixed(2));
    }
}
// Change print type
$(document).on("click", ".js-print-option", function() {
    let SelectedPrintType = $(this).attr("data-print");
    if ($991b8b8ca8b4a964$var$PrintType !== SelectedPrintType) {
        $991b8b8ca8b4a964$var$PrintType = SelectedPrintType;
        $991b8b8ca8b4a964$var$setPrintType($991b8b8ca8b4a964$var$PrintType);
    }
    if ($(this).hasClass("d-block")) $991b8b8ca8b4a964$var$PrintTypeSelected = true;
    $991b8b8ca8b4a964$var$togglePrintTypes();
});
$(document).on("click", ".js-show-print-types", function() {
    $991b8b8ca8b4a964$var$togglePrintTypes();
});
function $991b8b8ca8b4a964$var$setPrintType(PrintType) {
    var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
    $(".js-print-option").removeClass("active");
    selectedPrint.addClass("active");
    // If acryl
    if (PrintType == "acryl") {
        if ($991b8b8ca8b4a964$var$PosterSize === "large" || $991b8b8ca8b4a964$var$PosterSize === "extra-large") $991b8b8ca8b4a964$var$PosterSize = "small";
        if ($991b8b8ca8b4a964$var$PosterBGColor === "dark") {
            $991b8b8ca8b4a964$var$PosterBGColor = "light";
            $991b8b8ca8b4a964$var$setBGColor();
        }
        $991b8b8ca8b4a964$var$PosterFrame = "no-frame";
    // If aluminium
    } else if (PrintType == "aluminium") {
        if ($991b8b8ca8b4a964$var$PosterSize === "large" || $991b8b8ca8b4a964$var$PosterSize === "extra-large") $991b8b8ca8b4a964$var$PosterSize = "medium";
        if ($991b8b8ca8b4a964$var$PosterBGColor === "dark") {
            $991b8b8ca8b4a964$var$PosterBGColor = "light";
            $991b8b8ca8b4a964$var$setBGColor();
        }
        $991b8b8ca8b4a964$var$PosterFrame = "no-frame";
        $991b8b8ca8b4a964$var$setAluminiumColor($991b8b8ca8b4a964$var$AluminiumColor);
    // If paper
    } else {
        if ($991b8b8ca8b4a964$var$PosterSize === "xs") $991b8b8ca8b4a964$var$PosterSize = "small";
        else if ($991b8b8ca8b4a964$var$PosterSize === "extra-large") $991b8b8ca8b4a964$var$PosterSize = "large";
        $991b8b8ca8b4a964$var$AcrylBlock = "no-block";
    }
    $991b8b8ca8b4a964$var$setAcrylBlock($991b8b8ca8b4a964$var$AcrylBlock);
    $991b8b8ca8b4a964$var$setBlockSelection($991b8b8ca8b4a964$var$AcrylBlock);
    $991b8b8ca8b4a964$var$setFrameSelection($991b8b8ca8b4a964$var$PosterFrame);
    $991b8b8ca8b4a964$var$setPosterFrame($991b8b8ca8b4a964$var$PosterFrame);
    $991b8b8ca8b4a964$var$setPosterSize($991b8b8ca8b4a964$var$PosterSize);
    $991b8b8ca8b4a964$var$setSizeSelection($991b8b8ca8b4a964$var$PosterSize);
    $991b8b8ca8b4a964$var$calculatePosterPrice();
}
function $991b8b8ca8b4a964$var$togglePrintTypes() {
    if ($991b8b8ca8b4a964$var$PrintTypeSelected) {
        $(".js-print-option").hide();
        $(".js-toggle-for-material").hide();
        $(".js-show-print-types").show();
        $(".js-toggle-for-material[data-material*='" + $991b8b8ca8b4a964$var$PrintType + "']").show();
        $(".js-print-option[data-print='" + $991b8b8ca8b4a964$var$PrintType + "']").show();
        $991b8b8ca8b4a964$var$PrintTypeSelected = false;
    } else {
        $(".js-print-option").show();
        $(".js-show-print-types").hide();
        $(".js-toggle-for-material").hide();
        $991b8b8ca8b4a964$var$PrintTypeSelected = true;
    }
}
// Change aluminium color
$(".js-color-option").on("click", function() {
    $991b8b8ca8b4a964$var$AluminiumColor = $(this).attr("data-color");
    $991b8b8ca8b4a964$var$setAluminiumColor($991b8b8ca8b4a964$var$AluminiumColor);
    $991b8b8ca8b4a964$var$setAluminiumColorSelection($991b8b8ca8b4a964$var$AluminiumColor);
});
function $991b8b8ca8b4a964$var$setAluminiumColor(color) {
    $991b8b8ca8b4a964$var$PosterWrapper.attr("data-aluminium-color", color);
}
function $991b8b8ca8b4a964$var$setAluminiumColorSelection(color) {
    var selectedColor = $('.js-color-option[data-color="' + color + '"]');
    $(".js-color-option").removeClass("active");
    selectedColor.addClass("active");
}
// Change acryl block
$(".js-block-option").on("click", function() {
    $991b8b8ca8b4a964$var$AcrylBlock = $(this).attr("data-block");
    $991b8b8ca8b4a964$var$setBlockSelection($991b8b8ca8b4a964$var$AcrylBlock);
    $991b8b8ca8b4a964$var$setAcrylBlock($991b8b8ca8b4a964$var$AcrylBlock);
    $991b8b8ca8b4a964$var$calculatePosterPrice();
});
function $991b8b8ca8b4a964$var$setBlockSelection(AcrylBlock) {
    var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
    $(".js-block-option").removeClass("active");
    selectedBlock.addClass("active");
}
function $991b8b8ca8b4a964$var$setAcrylBlock(AcrylBlock) {
    $(".aluminium-stand").hide();
    $(".acryl-block").show();
    $991b8b8ca8b4a964$var$PosterWrapper.attr("data-perspective", false);
    if (AcrylBlock == "black") {
        $(".acryl-block").removeClass("d-none oak").addClass("black");
        $991b8b8ca8b4a964$var$PosterWrapper.attr("data-perspective", true);
    } else if (AcrylBlock == "oak") {
        $(".acryl-block").removeClass("d-none black").addClass("oak");
        $991b8b8ca8b4a964$var$PosterWrapper.attr("data-perspective", true);
    } else $(".acryl-block").removeClass("oak black").addClass("d-none");
}
// Change poster frame
$(".js-frame-option").on("click", function() {
    $991b8b8ca8b4a964$var$PosterFrame = $(this).attr("data-frame");
    $991b8b8ca8b4a964$var$setFrameSelection($991b8b8ca8b4a964$var$PosterFrame);
    $991b8b8ca8b4a964$var$setPosterFrame($991b8b8ca8b4a964$var$PosterFrame);
    $991b8b8ca8b4a964$var$calculatePosterPrice();
});
function $991b8b8ca8b4a964$var$setPosterFrame(PosterFrame) {
    const frameElement = $(".poster-frame");
    const frameClasses = [
        "black-frame",
        "oak-frame",
        "white-frame"
    ];
    frameElement.removeClass(frameClasses.join(" ") + " d-none");
    if (frameClasses.includes(PosterFrame + "-frame")) frameElement.addClass(PosterFrame + "-frame");
    else frameElement.addClass("d-none");
    $991b8b8ca8b4a964$var$activateGiftwrap();
}
function $991b8b8ca8b4a964$var$setFrameSelection(frame) {
    var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
    $(".js-frame-option").removeClass("active");
    selectedFrame.addClass("active");
}
// Get list of moments
function $991b8b8ca8b4a964$var$loadMoments() {
    (0, (/*@__PURE__*/$parcel$interopDefault($8bce9c5f32149532$exports))).moments.forEach((_moment, index)=>{
        const label = index === 0 ? $991b8b8ca8b4a964$var$t("starmap.defaults.customMoment") : $991b8b8ca8b4a964$var$t(`starmap.moments.${index}`);
        $991b8b8ca8b4a964$var$MomentSelector.append(`<option value="${label}">${label}</option>`);
    });
}
$991b8b8ca8b4a964$var$MomentSelector.on("change", function() {
    let moment = $(this).val();
    if (moment === $991b8b8ca8b4a964$var$t("starmap.defaults.customMoment")) {
        $991b8b8ca8b4a964$var$MomentInput.val($991b8b8ca8b4a964$var$t("starmap.defaults.event"));
        $991b8b8ca8b4a964$var$MomentLabel.html($991b8b8ca8b4a964$var$t("starmap.defaults.event"));
    } else {
        $991b8b8ca8b4a964$var$MomentInput.val(moment);
        $991b8b8ca8b4a964$var$MomentLabel.html(moment);
    }
    $991b8b8ca8b4a964$var$scaleFontSize();
});
// Toggle giftwrap
$(".js-giftwrap").on("change", function() {
    $991b8b8ca8b4a964$var$calculatePosterPrice();
});
function $991b8b8ca8b4a964$var$activateGiftwrap() {
    if ($991b8b8ca8b4a964$var$PrintType === "paper" && $991b8b8ca8b4a964$var$PosterFrame === "no-frame") {
        $991b8b8ca8b4a964$var$PosterGiftwrapSelect.val("false");
        $(".js-giftwrap option[value=true]").attr("disabled", "disabled").siblings().removeAttr("disabled");
    } else $(".js-giftwrap option[value=true]").removeAttr("disabled");
}
// Change giftcard text
$(".js-giftcard").on("change", function() {
    if ($(this).val() === "true") {
        $(".js-giftcard-text").show();
        $991b8b8ca8b4a964$var$GiftCardText = $(".js-giftcard-text").val();
    } else {
        $(".js-giftcard-text").hide();
        $991b8b8ca8b4a964$var$GiftCardText = "";
    }
    $991b8b8ca8b4a964$var$calculatePosterPrice();
});
$(".js-giftcard-text").on("change", function() {
    $991b8b8ca8b4a964$var$GiftCardText = $(this).val();
});
// Calculate poster price
function $991b8b8ca8b4a964$var$calculatePosterPrice() {
    const getPrice = (selector)=>parseFloat($(selector).find(".active, :selected").attr("data-price")) || 0;
    const subtotalPrice = getPrice($991b8b8ca8b4a964$var$PosterSizeSelect) + getPrice($991b8b8ca8b4a964$var$AcrylBlockSelect) + getPrice($991b8b8ca8b4a964$var$PosterFrameSelect) + getPrice($991b8b8ca8b4a964$var$PosterGiftwrapSelect) + getPrice($991b8b8ca8b4a964$var$GiftCardSelect);
    $(".subtotal").html($991b8b8ca8b4a964$var$formatCurrency(subtotalPrice));
}
// Create poster preview image
function $991b8b8ca8b4a964$var$createPosterPreview() {
    $(".poster-frame, .block-wrapper").addClass("hidden");
    $(".map-wrapper").addClass("shadow-none");
    const element = document.querySelector(".poster-wrapper");
    (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(element, {
        scale: window.devicePixelRatio || 2,
        useCORS: true,
        backgroundColor: "#ffffff"
    }).then((canvas)=>{
        $991b8b8ca8b4a964$var$PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
        $(".js-poster-preview").attr("src", $991b8b8ca8b4a964$var$PosterPreviewImage);
    });
    $(".map-wrapper").removeClass("shadow-none");
    $(".poster-frame, .block-wrapper").removeClass("hidden");
}
// For hiding some unnecessary fields on staging
function $991b8b8ca8b4a964$var$toggleProductionEnv() {}
// For saving design to local storage
function $991b8b8ca8b4a964$var$saveDesign() {
    localStorage.setItem("posterSize", $991b8b8ca8b4a964$var$PosterSize);
    localStorage.setItem("posterFrame", $991b8b8ca8b4a964$var$PosterFrame);
    localStorage.setItem("StarsMoment", $991b8b8ca8b4a964$var$MomentLabel.html());
    localStorage.setItem("StarsDate", $991b8b8ca8b4a964$var$StarsDate);
    localStorage.setItem("StarsTime", $991b8b8ca8b4a964$var$StarsTime);
    localStorage.setItem("StarsLat", $991b8b8ca8b4a964$var$StarsLat);
    localStorage.setItem("StarsLong", $991b8b8ca8b4a964$var$StarsLong);
    localStorage.setItem("StarsLocation", $991b8b8ca8b4a964$var$CoordinatesLabel.html());
    localStorage.setItem("StarsReadableDate", $991b8b8ca8b4a964$var$SubtitleLabel.html());
    localStorage.setItem("StarsSubtitle", $991b8b8ca8b4a964$var$Subtitle2Label.html());
    localStorage.setItem("SongFontStyle", $991b8b8ca8b4a964$var$PosterFontStyle);
    localStorage.setItem("printType", $991b8b8ca8b4a964$var$PrintType);
    localStorage.setItem("acrylBlock", $991b8b8ca8b4a964$var$AcrylBlock);
    localStorage.setItem("aluminiumColor", $991b8b8ca8b4a964$var$AluminiumColor);
    localStorage.setItem("ShowMilkyWay", $991b8b8ca8b4a964$var$ShowMilkyWay);
    localStorage.setItem("ShowConstellations", $991b8b8ca8b4a964$var$ShowConstellations);
    localStorage.setItem("ShowGlobe", $991b8b8ca8b4a964$var$ShowGlobe);
    localStorage.setItem("ShowTime", $991b8b8ca8b4a964$var$ShowTime);
    localStorage.setItem("PosterColorNumber", $991b8b8ca8b4a964$var$PosterColorNumber);
    localStorage.setItem("PosterBGColor", $991b8b8ca8b4a964$var$PosterBGColor);
    localStorage.setItem("PosterBorder", $991b8b8ca8b4a964$var$PosterBorder);
}
// For getting design from local storage or parameters
function $991b8b8ca8b4a964$var$getSavedPoster() {
    // Prepare text labels
    if ($991b8b8ca8b4a964$var$BuilderName !== "PrintApp") {
        if ($991b8b8ca8b4a964$var$options.get("StarsMoment") !== null) $991b8b8ca8b4a964$var$StarsMoment = $991b8b8ca8b4a964$var$options.get("StarsMoment");
        else $991b8b8ca8b4a964$var$StarsMoment = $991b8b8ca8b4a964$var$t("starmap.fields.moment");
        if ($991b8b8ca8b4a964$var$options.get("StarsLocation") !== null) $991b8b8ca8b4a964$var$StarsLocation = $991b8b8ca8b4a964$var$options.get("StarsLocation");
        else $991b8b8ca8b4a964$var$StarsLocation = `52\xb022'40.8"N 4\xb054'0.0"E`;
        if ($991b8b8ca8b4a964$var$options.get("StarsReadableDate") !== null) $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$options.get("StarsReadableDate");
        else $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$formatPosterDate($991b8b8ca8b4a964$var$StarsDate);
        $991b8b8ca8b4a964$var$loadMoments();
        $991b8b8ca8b4a964$var$loadColors();
        $991b8b8ca8b4a964$var$setPosterColorSelection($991b8b8ca8b4a964$var$PosterColorNumber);
        $991b8b8ca8b4a964$var$toggleBGColorSelect();
        $991b8b8ca8b4a964$var$toggleBorderSelect();
        $991b8b8ca8b4a964$var$TimePicker.val($991b8b8ca8b4a964$var$StarsTime);
        $991b8b8ca8b4a964$var$setTimeToggle();
        $991b8b8ca8b4a964$var$TimeToggle.prop("checked", $991b8b8ca8b4a964$var$ShowTime);
    } else {
        $991b8b8ca8b4a964$var$StarsMoment = $991b8b8ca8b4a964$var$options.get("StarsMoment");
        $991b8b8ca8b4a964$var$StarsLocation = $991b8b8ca8b4a964$var$options.get("StarsLocation");
        $991b8b8ca8b4a964$var$StarsReadableDate = $991b8b8ca8b4a964$var$options.get("StarsReadableDate");
    }
    // Set text labels
    $991b8b8ca8b4a964$var$MomentLabel.html($991b8b8ca8b4a964$var$StarsMoment);
    $991b8b8ca8b4a964$var$MomentInput.val($991b8b8ca8b4a964$var$StarsMoment);
    $991b8b8ca8b4a964$var$CoordinatesLabel.html($991b8b8ca8b4a964$var$StarsLocation);
    $991b8b8ca8b4a964$var$CoordinatesInput.val($991b8b8ca8b4a964$var$StarsLocation);
    $991b8b8ca8b4a964$var$SubtitleLabel.html($991b8b8ca8b4a964$var$StarsReadableDate);
    $991b8b8ca8b4a964$var$SubtitleInput.val($991b8b8ca8b4a964$var$StarsReadableDate);
    $991b8b8ca8b4a964$var$Subtitle2Label.html($991b8b8ca8b4a964$var$StarsSubtitle);
    $991b8b8ca8b4a964$var$Subtitle2Input.val($991b8b8ca8b4a964$var$StarsSubtitle);
    $991b8b8ca8b4a964$var$TimePicker.val($991b8b8ca8b4a964$var$StarsTime);
    if ($991b8b8ca8b4a964$var$PrintType !== "acryl" && $991b8b8ca8b4a964$var$PrintType !== "aluminium") {
        if ($991b8b8ca8b4a964$var$PosterSize === "xs") $991b8b8ca8b4a964$var$PosterSize = "small";
        if ($991b8b8ca8b4a964$var$PrintType === "framed-poster" || $991b8b8ca8b4a964$var$PrintType === "tegel") $991b8b8ca8b4a964$var$PrintType = "paper";
    }
    $991b8b8ca8b4a964$var$setPosterSize($991b8b8ca8b4a964$var$PosterSize);
    $991b8b8ca8b4a964$var$setAluminiumColor($991b8b8ca8b4a964$var$AluminiumColor);
    $991b8b8ca8b4a964$var$setAluminiumColorSelection($991b8b8ca8b4a964$var$AluminiumColor);
    $(".js-toggle-for-material").hide();
    $991b8b8ca8b4a964$var$togglePrintTypes();
    $991b8b8ca8b4a964$var$PosterFrameSelect.val($991b8b8ca8b4a964$var$PosterFrame);
    $991b8b8ca8b4a964$var$PrintTypeSelect.val($991b8b8ca8b4a964$var$PrintType);
    $991b8b8ca8b4a964$var$setPosterFontStyle($991b8b8ca8b4a964$var$PosterFontStyle);
    $991b8b8ca8b4a964$var$setPosterFontSelection($991b8b8ca8b4a964$var$PosterFontStyle);
}
// Resize canvas
$(window).resize(function() {
    $991b8b8ca8b4a964$var$resizePosterWrapper();
});
function $991b8b8ca8b4a964$var$resizePosterWrapper() {
    (0, $6Kc1e.resizePosterPreview)();
}
window.visualViewport?.addEventListener("resize", $991b8b8ca8b4a964$var$resizePosterWrapper);
// Toggle settings panels
$(".js-settings-toggle").on("click", function() {
    var target = $(this).attr("data-target");
    $(".nav-link").removeClass("active");
    $(".nav-link[data-target=" + target + "]").addClass("active");
    if ($991b8b8ca8b4a964$var$ShowMobileSettingPanel == false) {
        $(".side-nav").addClass("shown");
        $991b8b8ca8b4a964$var$ShowMobileSettingPanel = true;
    }
    if (target === $991b8b8ca8b4a964$var$SettingsPanel) return;
    $(".settings-panel").addClass("d-none");
    $(".settings-panel." + target).removeClass("d-none");
    $(".nav-pills .nav-link").removeClass("active");
    $("#pills-" + target + "-tab").addClass("active");
    if (target == "shop" && $991b8b8ca8b4a964$var$SettingsPanel !== "shop") $991b8b8ca8b4a964$var$setPosterSummary();
    $(".options-container").scrollTop(0);
    $991b8b8ca8b4a964$var$SettingsPanel = target;
    $991b8b8ca8b4a964$var$saveDesign();
});
$(".js-close-settings").on("click", function() {
    $991b8b8ca8b4a964$var$dismissSettingsPanel();
});
function $991b8b8ca8b4a964$var$dismissSettingsPanel() {
    $(".side-nav").removeClass("shown");
    $991b8b8ca8b4a964$var$ShowMobileSettingPanel = false;
}
// Prepping shopping cart
function $991b8b8ca8b4a964$var$setPosterSummary() {
    (0, $gF0Ex.getShoppingBagSummary)($991b8b8ca8b4a964$var$PosterSize, $991b8b8ca8b4a964$var$PrintType, $991b8b8ca8b4a964$var$PosterFrame, $991b8b8ca8b4a964$var$AcrylBlock, $991b8b8ca8b4a964$var$t);
    $(".js-shipping-date").html((0, $47G0t.getShippingDate)({
        t: $991b8b8ca8b4a964$var$t,
        formatDate: $991b8b8ca8b4a964$var$formatLocaleDate
    }));
    $991b8b8ca8b4a964$var$createPosterPreview();
}
function $991b8b8ca8b4a964$var$getProductVariation() {
    const variationKey = $991b8b8ca8b4a964$var$PrintType === "paper" ? `${$991b8b8ca8b4a964$var$PosterSize}-${$991b8b8ca8b4a964$var$PosterFrame}` : $991b8b8ca8b4a964$var$PosterSize;
    const product = (0, $gtTze.resolveCatalogProduct)($991b8b8ca8b4a964$var$marketContext.catalog, "starmap", $991b8b8ca8b4a964$var$PrintType, variationKey);
    return {
        id: product?.id ?? null,
        variation_id: product?.variationId ?? null
    };
}
function $991b8b8ca8b4a964$var$isPrintApp() {
    return $("html").hasClass("PrintApp");
}
// Adding poster to cart
$(".js-save-poster").on("click", async function() {
    $991b8b8ca8b4a964$var$saveDesign();
    let ProductID = $991b8b8ca8b4a964$var$getProductVariation();
    $(this).html(`${$991b8b8ca8b4a964$var$t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`).prop("disabled", true);
    let thumbnailUrl;
    try {
        thumbnailUrl = await (0, $8UUYp.uploadProductScreenshot)($991b8b8ca8b4a964$var$PosterPreviewImage, $991b8b8ca8b4a964$var$BuilderName);
    } catch (error) {
        console.error("Product screenshot kon niet worden opgeslagen", error);
        $(this).html($991b8b8ca8b4a964$var$t("actions.addToCart")).prop("disabled", false);
        $(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$991b8b8ca8b4a964$var$t("sportsmap.errors.saveFailed")}</div>`);
        return;
    }
    let payload = {
        "add-builder-item-to-cart": true,
        edit_url: $991b8b8ca8b4a964$var$woocommerceUrl + "/builder/starmap-poster/?preview",
        thumbnail: thumbnailUrl,
        product_id: ProductID.id,
        variation_id: ProductID.variation_id,
        poster: {
            printType: $991b8b8ca8b4a964$var$PrintType,
            size: $991b8b8ca8b4a964$var$PosterSize,
            giftwrap: $991b8b8ca8b4a964$var$PosterGiftwrapSelect.val(),
            giftcardText: $991b8b8ca8b4a964$var$GiftCardText,
            StarsMoment: localStorage.getItem("StarsMoment"),
            StarsLocation: localStorage.getItem("StarsLocation"),
            StarsReadableDate: localStorage.getItem("StarsReadableDate"),
            StarsSubtitle: localStorage.getItem("StarsSubtitle"),
            StarsLat: localStorage.getItem("StarsLat"),
            StarsLong: localStorage.getItem("StarsLong"),
            StarsDate: localStorage.getItem("StarsDate"),
            StarsTime: localStorage.getItem("StarsTime"),
            ShowMilkyWay: localStorage.getItem("ShowMilkyWay"),
            ShowConstellations: localStorage.getItem("ShowConstellations"),
            ShowGlobe: localStorage.getItem("ShowGlobe"),
            ShowTime: localStorage.getItem("ShowTime"),
            SongFontStyle: localStorage.getItem("SongFontStyle"),
            ...[
                "aluminium"
            ].includes($991b8b8ca8b4a964$var$PrintType) && {
                aluminiumColor: localStorage.getItem("aluminiumColor")
            },
            ...[
                "aluminium",
                "acryl",
                "tegel"
            ].includes($991b8b8ca8b4a964$var$PrintType) && {
                acrylBlock: localStorage.getItem("acrylBlock")
            },
            ...[
                "paper"
            ].includes($991b8b8ca8b4a964$var$PrintType) && {
                frame: $991b8b8ca8b4a964$var$PosterFrame
            },
            PosterColorNumber: localStorage.getItem("PosterColorNumber"),
            PosterBGColor: localStorage.getItem("PosterBGColor"),
            PosterBorder: localStorage.getItem("PosterBorder"),
            main: localStorage.getItem("StarsMoment"),
            subtitle: localStorage.getItem("StarsLocation"),
            subtitle2: localStorage.getItem("StarsSubtitle")
        },
        pdf: {
            type: "starmap",
            print: $991b8b8ca8b4a964$var$PrintType === "paper" && $991b8b8ca8b4a964$var$PosterFrame !== "no-frame" ? "framed-poster" : $991b8b8ca8b4a964$var$PrintType
        }
    };
    // console.log("Payload: ", payload);
    let action = "add-to-cart";
    const endpoint = $991b8b8ca8b4a964$var$apiBase + "/wp-json/wallable/v1/" + action;
    let didRetryAsForm = false;
    const runAjax = (useFormEncoding = false)=>{
        return $.ajax({
            url: endpoint,
            type: "POST",
            timeout: 20000,
            ...useFormEncoding ? {
                data: {
                    payload: JSON.stringify(payload)
                }
            } : {
                contentType: "application/json",
                data: JSON.stringify(payload)
            },
            error: (jqXHR, textStatus, errorThrown)=>{
                if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
                    didRetryAsForm = true;
                    return runAjax(true);
                }
                console.error(jqXHR, textStatus, errorThrown);
                setTimeout(()=>{
                    if (!$(".js-notifications").find(".js-error").length) $(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$991b8b8ca8b4a964$var$t("errors.generic")}</div>`);
                    $991b8b8ca8b4a964$var$debugReporter.show({
                        meta: {
                            action: action,
                            didRetryAsForm: didRetryAsForm
                        },
                        request: {
                            url: endpoint,
                            method: "POST",
                            mode: useFormEncoding ? "form" : "json",
                            origin: window.location.origin,
                            woocommerceUrl: $991b8b8ca8b4a964$var$woocommerceUrl,
                            online: navigator.onLine,
                            visibilityState: document.visibilityState
                        },
                        response: {
                            status: jqXHR?.status,
                            statusText: jqXHR?.statusText || textStatus,
                            thrownError: errorThrown ? String(errorThrown) : null,
                            responseText: (jqXHR?.responseText || "").slice(0, 4000)
                        }
                    });
                    $(this).html($991b8b8ca8b4a964$var$t("actions.addToCart")).prop("disabled", false);
                }, 500);
            },
            success: ()=>{
                if (action === "add-to-cart") {
                    $(this).html($991b8b8ca8b4a964$var$t("actions.addToCart")).prop("disabled", false);
                    window.location = $991b8b8ca8b4a964$var$woocommerceUrl + "/cart/";
                } else {
                    if (!$(".js-notifications").find(".js-error").length) $(".js-notifications").append(`<div class="js-success alert alert-success text-center p-2">&#x2713; ${$991b8b8ca8b4a964$var$t("actions.posterAdded")}</div>`);
                    $(this).html($991b8b8ca8b4a964$var$t("actions.addToCart")).prop("disabled", false);
                }
            }
        });
    };
    runAjax(false);
});
// Tooltips
if (!$991b8b8ca8b4a964$var$isPrintApp()) {
    var $991b8b8ca8b4a964$var$tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var $991b8b8ca8b4a964$var$tooltipList = $991b8b8ca8b4a964$var$tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new $k4QTz.Tooltip(tooltipTriggerEl);
    });
}


//# sourceMappingURL=starmap-poster.32352626.js.map
